"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _sponsoredModule = _interopRequireDefault(require("./sponsored.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var Sponsored = function Sponsored(_ref) {
  var _ref$hasSponsoredTitl = _ref.hasSponsoredTitle,
    hasSponsoredTitle = _ref$hasSponsoredTitl === void 0 ? false : _ref$hasSponsoredTitl,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  if (!hasSponsoredTitle) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
    "aria-label": 'Sponsored product',
    className: (0, _classnames.default)(_sponsoredModule.default['sponsored-text'], className),
    "data-testid": "sponsored-product-tag",
    children: "Sponsored"
  });
};
Sponsored.propTypes = {
  hasSponsoredTitle: _propTypes.default.bool,
  className: _propTypes.default.string
};
var _default = exports.default = /*#__PURE__*/(0, _react.memo)(Sponsored);